var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdPlayLesson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3018 5.59375C11.3018 4.35111 12.3091 3.34375 13.5518 3.34375H17.399C18.6417 3.34375 19.649 4.35111 19.649 5.59375V5.73882L20.7879 4.99568C21.0184 4.84525 21.3128 4.83319 21.5549 4.96427C21.797 5.09536 21.9478 5.34851 21.9478 5.62378V9.12378C21.9478 9.39905 21.797 9.6522 21.5549 9.78329C21.3128 9.91437 21.0184 9.90231 20.7879 9.75188L19.649 9.00874V9.15381C19.649 10.3964 18.6417 11.4038 17.399 11.4038H13.5518C12.3091 11.4038 11.3018 10.3964 11.3018 9.15381V5.59375Z",
    fill: "currentColor",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80176 5.59375C9.80176 5.21327 9.85842 4.84603 9.96377 4.5H4.25C3.00736 4.5 2 5.50736 2 6.75V15.3438C2 16.5864 3.00736 17.5938 4.25 17.5938H11.25V19.25H9.00003C8.58582 19.25 8.25003 19.5858 8.25003 20C8.25003 20.4142 8.58582 20.75 9.00003 20.75H15C15.4142 20.75 15.75 20.4142 15.75 20C15.75 19.5858 15.4142 19.25 15 19.25H12.75V17.5938H19.75C20.9926 17.5938 22 16.5864 22 15.3438V11.2259C21.5167 11.4105 20.9867 11.4216 20.5001 11.263C19.8252 12.2534 18.6881 12.9038 17.399 12.9038H13.5518C11.4807 12.9038 9.80176 11.2249 9.80176 9.15381V5.59375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdPlayLesson);
export default __webpack_public_path__ + "static/media/MdPlayLesson.4bcbef1d299d1f22a98bb601933519d6.svg";
export { ForwardRef as ReactComponent };